const routes = [
  {
    name: 'home',
    path: '/',
  },
  {
    name: 'cauldron',
    path: '/cauldron', 
  }
]

export default routes